/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DocumentStampedV1Dto } from './DocumentStampedV1Dto';
import type { TicketPointOfSaleV1Dto } from './TicketPointOfSaleV1Dto';
import type { YouSignSignatureToDocumentV1Dto } from './YouSignSignatureToDocumentV1Dto';
export type TicketDocumentV1Dto = {
  /**
   * The unique identifier of the document.
   */
  id: string;
  /**
   * The current version of the entity
   */
  documentInternalVersion: number;
  /**
   * The id for the document in the document table.
   */
  documentInternalId: string;
  /**
   * The unique identifier of the email of the attachment. Set only in case of attachment
   */
  emailId?: string | null;
  /**
   * The type of kind. (email or attachment)
   */
  kind: TicketDocumentV1Dto.kind;
  /**
   * The entry date of the document.
   */
  entryDate?: string;
  /**
   * The type of the document.
   */
  documentType?: TicketDocumentV1Dto.documentType;
  /**
   * corresponding to the pos
   */
  pointOfSale?: TicketPointOfSaleV1Dto;
  /**
   * mimeType of the document
   */
  mimeType?: string;
  /**
   * name of the document
   */
  name?: string;
  /**
   * ID corresponding to the document in document service
   */
  documentId?: string;
  /**
   * Version of corresponding to the document in document service
   */
  documentVersion?: string;
  /**
   * The flag to indicate if the document is stamped.
   */
  stamped?: boolean;
  /**
   * comment
   */
  comment?: string;
  documentStamped?: DocumentStampedV1Dto | null;
  signatureRequests?: Array<YouSignSignatureToDocumentV1Dto> | null;
};
export namespace TicketDocumentV1Dto {
  /**
   * The type of kind. (email or attachment)
   */
  export enum kind {
    EMAIL = 'EMAIL',
    ATTACHMENT = 'ATTACHMENT',
    UPLOADED_DOCUMENT = 'UPLOADED_DOCUMENT',
  }
  /**
   * The type of the document.
   */
  export enum documentType {
    LEASE_AGREEMENT = 'LeaseAgreement',
    LEASE_ADDITIONAL_AGREEMENTS = 'LeaseAdditionalAgreements',
    LEASE_SPECIAL_USE_AGREEMENT = 'LeaseSpecialUseAgreement',
    LEASE_PREVIOUS_AGREEMENT = 'LeasePreviousAgreement',
    LEASE_SUPPLEMENT = 'LeaseSupplement',
    LEASE_RENT_INVOICE = 'LeaseRentInvoice',
    LEASE_RENT_DUNNING_NOTICE = 'LeaseRentDunningNotice',
    LEASE_RENT_INDEX_INVOICE = 'LeaseRentIndexInvoice',
    LEASE_RENT_INDEX_LETTER = 'LeaseRentIndexLetter',
    LEASE_RENT_ADJUSTMENT = 'LeaseRentAdjustment',
    LEASE_TERMINATION_LETTER = 'LeaseTerminationLetter',
    LEASE_OPTION_OR_EXTENSION_LETTER = 'LeaseOptionOrExtensionLetter',
    LEASE_CONTRACT_MISC_CORRESPONDENCE = 'LeaseContractMiscCorrespondence',
    LEASE_HANDOVER_REPORT = 'LeaseHandoverReport',
    LEASE_RETURN_HANDOVER_REPORT = 'LeaseReturnHandoverReport',
    LEASE_OWNER_OR_CONTACT_CHANGE = 'LeaseOwnerOrContactChange',
    LEASE_CONTACT_DATA = 'LeaseContactData',
    LEASE_SECURITY_DEPOSIT = 'LeaseSecurityDeposit',
    MISCELLANEOUS_CORRESPONDENCE = 'MiscellaneousCorrespondence',
    OPERATING_COST_INVOICE = 'OperatingCostInvoice',
    OPERATING_COST_CORRECTION = 'OperatingCostCorrection',
    OPERATING_COST_CREDIT_NOTE = 'OperatingCostCreditNote',
    OPERATING_COST_SUPPORTING_DOCUMENTS = 'OperatingCostSupportingDocuments',
    OPERATING_COST_OBJECTION_LETTER = 'OperatingCostObjectionLetter',
    OPERATING_COST_MISC_CORRESPONDENCE = 'OperatingCostMiscCorrespondence',
    FMCONTRACT = 'FMContract',
    FMINVOICE = 'FMInvoice',
    FMDUNNING_NOTICE = 'FMDunningNotice',
    FMINSPECTION_REPORT = 'FMInspectionReport',
    FMPLANS = 'FMPlans',
    FMPHOTOS = 'FMPhotos',
    FMOFFER = 'FMOffer',
    FMINCIDENT_REPORT = 'FMIncidentReport',
    FMCONTACT_DATA = 'FMContactData',
    FMMISC_CORRESPONDENCE = 'FMMiscCorrespondence',
  }
}
